var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExport = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 14,
  viewBox: "0 0 12 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.1508 12.0754C11.1508 12.3239 11.0514 12.5526 10.8824 12.7316C10.7133 12.9105 10.4747 13 10.2262 13H1.92461C1.67606 13 1.44739 12.9006 1.26843 12.7316C1.09942 12.5626 1 12.3239 1 12.0754V1.92461C1 1.67606 1.09942 1.44739 1.26843 1.26843C1.43745 1.09942 1.67606 1 1.92461 1H7.92958L11.1607 4.23115V12.0754H11.1508Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.92011 7.91943L6.07089 9.76865L4.22168 7.91943",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.08105 9.76835V4.68799",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgExport;